import React from 'react'
import { notification } from 'antd'

export default class Address {
    constructor() {
        this.required = false
        this.errors = []
        this.data = {}
        this.isValid = true
        this.autoValidate = true

    }

    validate() {
        this.errors = []
        if (!this.data.street || this.data.street.length < 4) {
            this.errors.push("Rua inválida")
        }
        if (!this.data.district) {
            this.errors.push("Bairro inválido")
        }
        if (!this.data.postal_code || this.data.postal_code.length < 6) { 
            this.errors.push("CEP inválido")
        }
        if (!this.data.state_location) {
            this.errors.push("Estado inválido")
        }
        if (!this.data.city_location) {
            this.errors.push("Cidade inválida")
        }

        this.isValid = this.errors.length === 0
    }
    showNotificationErrors() {
        const errors = this.errors.map((error, i) => <li key={i}>{error}</li>)
        notification.open({
            type: "error",
            message: "Corrija os erros abaixo:",
            description: <ul>{errors}</ul>,
            duration: 3,
            key: 123
        })
    }

    initFromProps(props) {
        this.data.street = props.street
        this.data.street_number = props.streetNumber
        this.data.complement = props.complement
        this.data.district = props.district
        this.data.postal_code = props.postalCode
        this.data.city_location = props.cityLocation.id
        this.data.state_location = props.stateLocation.id

        if (this.autoValidate) {
            this.validate()
        }
    }


}



// WEBPACK FOOTER //
// ./src/models/base/address.js